module.exports = __webpack_public_path__ + "img/20190809162716734.6f28ca05.png";